import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Tooltip from '../Tooltip'
import Clock from '../../features/Clock'
import attributes from '../../settings/references.json'
import { launcherOpenUrl } from '../../launcherBackend/launcher-command'
import styles from './side-menu.scss'

class SideMenu extends Component {
    // Generate Account Management link, with appropriate origin query parameter
    getAccountManagement = () => {
        // Retrieve the account management link from
        // the resource file
        let accountManagement = attributes.link.accountManagement

        // Append the appropriate origin query parameter
        accountManagement += `?lan=${this.props.locale}&origin=${
            this.props.steamStartup
                ? attributes.launcher.origin.steam
                : attributes.launcher.origin.default
        }`

        return accountManagement
    }

    renderLogo = () => {
        const title = this.props.localize('logoDescription')
        return (
            <Tooltip content={this.props.localize('externalLink')}>
                <div className={styles.launcherLogo}>
                    <a
                        role="button"
                        tabIndex="0"
                        onKeyPress={e => launcherOpenUrl(attributes.link.logoUrl, e)}
                        onClick={() => launcherOpenUrl(attributes.link.logoUrl)}
                    >
                        <img
                            src="https://web.ccpgamescdn.com/eveonlineassets/launcher/backgrounds/eve_logo.png"
                            alt={title}
                        />
                    </a>
                </div>
            </Tooltip>
        )
    }

    renderButton = (title, tooltip, className, onKeyPress, onClick, dataFor = null) => (
        <Tooltip content={tooltip}>
            <li>
                <a
                    role="button"
                    tabIndex="0"
                    onKeyPress={event => onKeyPress(event)}
                    onClick={() => onClick()}
                    data-for={dataFor}
                >
                    <span className={className} />
                    <span className={styles.itemText}>{title}</span>
                </a>
            </li>
        </Tooltip>
    )

    renderTwitchButton = () => {
        if (!this.props.twitch.streaming) return null

        return this.renderButton(
            this.props.localize('twitch'),
            this.props.twitch.name,
            `fa fa-twitch ${styles.twitch}`,
            e => launcherOpenUrl(this.props.twitch.url, e),
            () => launcherOpenUrl(this.props.twitch.url),
        )
    }

    renderRefreshButton = () => {
        if (!this.props.updateAvailable) return null

        return this.renderButton(
            this.props.localize('updateTitle'),
            <div>
                <p>{this.props.localize('updateTooltip')}</p>
                <p>{this.props.localize('updateWarning')}</p>
            </div>,
            'flaticon flaticon-refresh57',
            (e) => {
                if (e.key === ' ') window.location.replace(`/${this.props.newVersion}`)
            },
            () => window.location.replace(`/${this.props.newVersion}`),
            'update',
        )
    }

    renderAccountButton = () =>
        this.renderButton(
            this.props.localize('account'),
            this.props.localize('externalLink'),
            'flaticon flaticon-network60',
            e => launcherOpenUrl(this.getAccountManagement(), e),
            () => launcherOpenUrl(this.getAccountManagement()),
        )

    renderSupportButton = () =>
        this.renderButton(
            this.props.localize('support'),
            this.props.localize('externalLink'),
            'flaticon flaticon-headset1',
            e => launcherOpenUrl(attributes.link.customerSupport, e),
            () => launcherOpenUrl(attributes.link.customerSupport),
        )

    renderOpenSettingsButton = () =>
        this.renderButton(
            this.props.localize('openSettings'),
            '',
            'flaticon flaticon-settings21',
            (e) => {
                if (e.key === ' ') this.props.toggleSettings()
            },
            () => this.props.toggleSettings(),
        )

    renderCloseSettingsButton = () => (
        <div
            className={styles.closeButton}
            role="button"
            tabIndex="0"
            onKeyPress={(event) => {
                if (event.key === ' ') this.props.toggleSettings()
            }}
            onClick={() => this.props.toggleSettings()}
        >
            <div>
                <span className={'flaticon flaticon-settings21'} />
                <span className={styles.itemText}>{this.props.localize('closeSettings')}</span>
            </div>
        </div>
    )

    render() {
        try {
            let content = null

            if (this.props.settingsOpen) {
                content = (
                    <div className={styles.closeContainer}>
                        {this.renderCloseSettingsButton()}
                        <Clock />
                    </div>
                )
            } else {
                content = (
                    <div className={styles.navigationBottom}>
                        <ul className={styles.list}>
                            {this.renderRefreshButton()}
                            {this.renderTwitchButton()}
                            {this.renderAccountButton()}
                            {this.renderSupportButton()}
                            {this.renderOpenSettingsButton()}
                        </ul>
                        <Clock />
                    </div>
                )
            }

            return (
                <div className={styles.leftBar}>
                    {this.renderLogo()}
                    {content}
                </div>
            )
        } catch (error) {
            console.info(`Error occurred while rendering side-menu: ${error.message}`)
        }
    }
}

SideMenu.propTypes = {
    steamStartup: PropTypes.bool,
    twitch: PropTypes.shape({
        streaming: PropTypes.bool,
        name: PropTypes.string,
        url: PropTypes.string,
    }),
    updateAvailable: PropTypes.bool,
    newVersion: PropTypes.string,
    localize: PropTypes.func,
    locale: PropTypes.string,
    settingsOpen: PropTypes.bool,
    toggleSettings: PropTypes.func,
}

SideMenu.defaultProps = {
    steamStartup: false,
    locale: 'en',
}

export default SideMenu



// WEBPACK FOOTER //
// ./src/components/SideMenu/side-menu.js